import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Evaluation/ValueAnalysis/Domain/commands-core';
import { Component } from 'vue-facing-decorator';

@Component
export default class ValueAnalysisCommands extends VueCqrs {

	invokeSaveResultsToNewAttributeCommandV1(userId: number, workspaceId: number, projectId: number, evalModelId: number, newAttributeName: string, values: string[])
	{
		const cmd = new c.SaveResultsToNewAttributeCommandV1(userId, workspaceId, projectId, evalModelId, newAttributeName, values);
		this.$command(cmd);
	}

	invokeSaveResultsToExistingAttributeCommandV1(userId: number, workspaceId: number, projectId: number, evalModelId: number, attributeId: number, values: string[])
	{
		const cmd = new c.SaveResultsToExistingAttributeCommandV1(userId, workspaceId, projectId, evalModelId, attributeId, values);
		this.$command(cmd);
	}
}
